<section class="page-section section-auth section-passwordforgot">

    <div class="background-effect"></div>

    <auth-header></auth-header>

    <div class="ui-view-main">

        <div class="container">
            <div class="row">
                <div class="col col-6 col-offset-3">
                    <h2 class="align-center">
                        <span [innerHTML]="'auth.headers.password_forgotten' | translate"></span>
                    </h2>
                </div>
            </div>

            <div class="row">
                <div class="col col-6 col-offset-3">
                    <div markdown ngPreserveWhitespaces class="intro markdown">
                        {{ 'auth.text.password_forgotten' | translate }}
                    </div>
                </div>
            </div>

            <div class="row">

                <div class="col col-6 col-offset-3">
                    <form (ngSubmit)="onSubmit()">
                        <div class="form-group">
                            <label for="email" [innerHTML]="'auth.labels.form.email' | translate"></label>
                            <input class="form-control" type="email" name="email" id="email" [(ngModel)]="email"
                                   placeholder="{{ 'auth.labels.form.email' | translate}}">
                            <ng-container *ngIf="errorMessages.length">
                                <span
                                  *ngFor="let error of errorMessages"
                                  class="form-validation error"
                                  [innerHTML] ="error | translate"
                                ></span>
                            </ng-container>
                        </div>
                        <div class="form-actions form-group">
                            <a routerLink="/"
                               class="btn-txt"
                               [innerHTML]="'general.buttons.back' | translate"
                            ></a>
                            <button class="btn-default float-right"
                                    type="submit"
                            >
                                <span [innerHTML]="'auth.buttons.forgot_submit' | translate"></span>
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>

</section>
